import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "../components/flexproducts";
import Header from "../headers_footer/header";

const Facecream = () => {

return (

<div>

<Navbar />
<Flexproducts type="facecream" />
<Header></Header>

</div>

);
};

export default Facecream;